import React from 'react';

function renderDistinctionBadges(card) {
  const pills = card.distinctionBadges?.length
    ? card.distinctionBadges
    : (card.distinctionBadge ? [card.distinctionBadge] : []);
  if (!pills.length) {
    return null;
  }
  return pills.map((pill) => (
    <span key={pill} className="badge badge-secondary me-1">{pill}</span>
  ));
}

export function MatchV2CardPreview({ cards = [] }) {
  if (!cards.length) {
    return <p className="small text-muted">No client cards to preview.</p>;
  }

  return (
    <div className="match-v2-preview-list">
      {cards.map((card) => (
        <div key={card.crm_id || card.id} className="match-v2-preview-card border rounded p-2 mb-2">
          <div className="d-flex gap-2">
            {card.photo && (
              <img src={card.photo} alt="" style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover' }} />
            )}
            <div>
              <strong>{card.name}</strong>
              {card.city && <div className="small text-muted">{card.city}</div>}
              {card.expertTopic?.label && (
                <div className="small">{card.expertTopic.label}</div>
              )}
              {!card.expertTopic?.label && card.expertTopic?.shortLabel && (
                <div className="small">
                  {`${card.expertTopic.prefix || 'Ekspert:'} ${card.expertTopic.shortLabel}`}
                </div>
              )}
              {renderDistinctionBadges(card)}
            </div>
          </div>
          {card.comment && <p className="small mt-2 mb-1">{`„${card.comment}"`}</p>}
          {card.evidenceLine && <p className="small mb-1">{card.evidenceLine}</p>}
          {card.ratingDisplay && <p className="small mb-1">{card.ratingDisplay}</p>}
          <div className="small">
            {card.metaLine || card.price30minLabel || card.price30minFormatted}
          </div>
        </div>
      ))}
    </div>
  );
}
